import styled from 'styled-components';
import { getTheme, ifProp } from 'mol-ui';

export const Container = styled.div`
    align-items: center;
    border-bottom: 1px solid ${ getTheme('disabledColor') };
    display: flex;
    flex-direction: column;
    padding: 10px 10px;
    width: 100%;
`;

export const Filters = styled.div.withConfig({
    shouldForwardProp: prop => !['hidden'].includes(prop)
})`
    ${ ifProp('hidden', 'display: none;') };
    width: 100%;
`;
